import { LoadMessages } from '@cld/intl';

// eslint-disable-next-line @typescript-eslint/no-unsafe-return
export const loadMessages: LoadMessages = (locale) => import(`./${locale}.json`);
export { messages } from './messages';
